export class Transformation {
  static readonly placeHolder = ' ';
  static readonly deletedPlaceHolder = '--Deleted User--';

  static user(obj: any) {
    if (!obj && !obj.username) {
      return obj;
    }
    const { firstName, lastName, attributes, username, email } = obj;

    const fullNameParts = [
      firstName || Transformation.placeHolder,
      lastName || Transformation.placeHolder,
    ].filter((part) => part && part.trim() !== '');

    let fullName =
      fullNameParts.join(Transformation.placeHolder) + ` [${username}`;
    if (attributes && attributes.uid && attributes.uid[0]) {
      fullName += `-${attributes.uid[0]}]`;
    } else {
      fullName += `]`;
    }

    return {
      ...obj,
      fullName,
      email: email || Transformation.placeHolder,
      uid:
        (attributes && attributes.uid && attributes.uid[0]) ||
        Transformation.placeHolder,
      phoneNumber:
        (attributes &&
          attributes.workMobilePhone &&
          attributes.workMobilePhone[0]) ||
        Transformation.placeHolder,
    };
  }

  static deletedUser(id: string) {
    return {
      id,
      fullName: Transformation.deletedPlaceHolder,
      firstName: Transformation.deletedPlaceHolder,
      lastName: Transformation.deletedPlaceHolder,
      email: Transformation.deletedPlaceHolder,
      uid: Transformation.deletedPlaceHolder,
      phoneNumber: Transformation.deletedPlaceHolder,
      enabled: false,
    };
  }
}
